import React from 'react';

import { MyFundsRequests } from 'features/funds-request';

export const TraderActiveFundsRequests: React.FC = () => (
  <MyFundsRequests active />
);
